import PageLayout from "@/components/feature/PageLayout";
import { Link } from "react-router-dom";

export default function RefundPage() {
  return (
    <PageLayout>
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="mb-1">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Billing &amp; Payments</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Where is my refund?</h2>
        <div className="space-y-4 text-sm">
          <p className="text-gray-500">
            Refunds typically take <strong className="text-gray-700">14 business days</strong> to appear in your account after they have been processed on our end.
          </p>
          <h4 className="font-semibold text-gray-800">Refund timeline:</h4>
          <ul className="list-disc list-inside space-y-2 text-gray-500">
            <li><strong className="text-gray-700">Processing:</strong> 1–3 business days after approval</li>
            <li><strong className="text-gray-700">Bank processing:</strong> 5–10 business days</li>
            <li><strong className="text-gray-700">Credit card statement:</strong> May appear on your next billing cycle</li>
          </ul>
          <h4 className="font-semibold text-gray-800">If you haven&apos;t received your refund:</h4>
          <ol className="list-decimal list-inside space-y-2 text-gray-500">
            <li>Check your bank or credit card statement for a credit from &quot;Kingcraft Technologies LTD&quot;</li>
            <li>Contact your bank to confirm no pending credits are being held</li>
            <li>If 14 business days have passed, contact our support team with your transaction ID</li>
          </ol>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p className="text-sm text-gray-500">
              <strong className="text-gray-700">Note:</strong> Refunds are returned to the original payment method used at the time of purchase.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <Link to="/contact-support" className="inline-block bg-[#2d2f36] text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center">
            Contact Support
          </Link>
          <Link to="/dispute-resolution" className="inline-block border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center">
            Submit a Dispute Form
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
